export default "__VITE_PUBLIC_ASSET__fefead11__"